import { OverlayControlButton } from '@/components/OverlayControlButton'
import DownChevronIcon from '@/CustomIcons/DownChevronIcon'
import HomeIcon from '@/CustomIcons/HomeIcon'
import StudioIcon from '@/CustomIcons/StudioIcon'
import { useRoomContext } from '@/RoomContext'
import { AnalyticsEvents } from '@/services/AnalyticsService'
import useAnalytics from '@/services/useAnalytics'
import useRoomActions from '@/services/useRoomActions'
import { SimpleMenu, SimpleMenuItem } from '@/UIComponents2/SimpleMenu'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { sessionSettingsTrigger } from '../../SessionPage'
import { Button } from '@/UIComponents2/Button'
import GearIcon from '@/CustomIcons/GearIcon'

export function StudioRoomOverlayControls() {
    const { t } = useTranslation()
    const [roomState] = useRoomContext()
    const { switchRoom } = useRoomActions()
    const { logUserActivityWithContext } = useAnalytics()

    const roomUrn = roomState.roomUrn || roomState.preRoomUrn

    const handleJoin = async (subroomUrn: string) => {
        if (roomUrn === subroomUrn) {
            return
        }

        if (roomState.parentRoomUrn === subroomUrn) {
            logUserActivityWithContext(AnalyticsEvents.CLICKED_JOIN_MAIN_ROOM_SESSION)
        } else {
            logUserActivityWithContext(AnalyticsEvents.CLICKED_JOIN_BREAKOUT_SESSION, { subroomUrn })
        }

        switchRoom(subroomUrn)
    }

    const subrooms = roomState.subrooms || []
    const subroomItems = useMemo(() => {
        let items: SimpleMenuItem[] = [
            {
                label: 'Main Room',
                onClick: () => {
                    handleJoin(roomState.parentRoomUrn || roomUrn || '')
                },
            },
        ]
        for (const subroom of subrooms) {
            items.push({
                label: subroom.name,
                onClick: () => {
                    handleJoin(subroom._id)
                },
            })
        }
        if (roomState.isHost) {
            items.push({
                label: (
                    <Button
                        variant="rectangle"
                        className="text-muse-yellow justify-center"
                        onClick={() => {
                            sessionSettingsTrigger.trigger({ tab: 'studios' })
                        }}
                    >
                        <GearIcon /> {t('Manage Studios')}
                    </Button>
                ),
                asChild: true,
                className: 'px-4 pt-2',
            })
        }
        return items
    }, [subrooms, roomUrn, roomState.parentRoomUrn])

    const roomName = roomState.parentRoomUrn ? roomState.name : 'Main Room'

    return (
        <div className="absolute top-2 left-1/2 -translate-x-1/2 z-16">
            <SimpleMenu className="w-[300px]" items={subroomItems}>
                <div>
                    <OverlayControlButton className="t-sm border-muse-toplit-low flex gap-3 px-4 aspect-auto">
                        {roomState.parentRoomUrn ? (
                            <StudioIcon style={{ fontSize: '1.3rem' }} />
                        ) : (
                            <HomeIcon style={{ fontSize: '1.3rem' }} />
                        )}
                        {roomName}
                        <DownChevronIcon className="opacity-65" style={{ fontSize: '1.1rem' }} />
                    </OverlayControlButton>
                </div>
            </SimpleMenu>
        </div>
    )
}
